module.exports = __webpack_public_path__ + "static/media/checkGreen.be8aef9d.svg";